import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=3d970374&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=3d970374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d970374",
  null
  
)

export default component.exports